/** Hold words for process outputs: "On hold · run problem", "Held · lab result". */
const REASON: Record<string, string> = {
  RUN_EXCEPTION: 'run problem',
  RECALL: 'recall',
  SUPERVISOR_HOLD: 'supervisor',
  QUALITY_CHECK: 'quality check',
  LAB_TEST: 'lab test',
}

/** First word of a reason ("LAB_LOQ LR-F7-…" → "LAB_LOQ") in plain words. */
export function holdReasonText(reason: string): string {
  const code = reason.trim().split(/\s+/)[0] ?? ''
  if (REASON[code]) return REASON[code]
  if (code.startsWith('LAB_')) return 'lab result'
  return code.replace(/_/g, ' ').toLowerCase()
}

export function holdText(hold: string, reasons: string[]): string | undefined {
  if (hold === 'NONE') return undefined
  const base = hold === 'HELD' ? 'Held' : hold === 'RECALLED' ? 'Recalled' : 'On hold'
  const words = [...new Set(reasons.map(holdReasonText).filter(Boolean))]
  return words.length ? `${base} · ${words.join(', ')}` : base
}
